import { memo } from 'react';

import { ReportProfileActions } from '@/features/profile/components/reportProfileActions';

export interface ProfileDetailsHeaderActionsProps {
  userId: string;
  isDuo?: boolean;
}

export const ProfileDetailsHeaderActions = memo(
  function ProfileDetailsHeaderActions(
    props: ProfileDetailsHeaderActionsProps,
  ) {
    const { userId, isDuo } = props;

    return (
      <ReportProfileActions
        userId={userId}
        isDuo={isDuo}
        triggerClassName="absolute right-0 text-cold-400 p-0 h-auto"
        data-no-flip
      />
    );
  },
);
